import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationDefaultIsShowPlanIncludedPrice = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { isShowPlanIncludedPrice } = viewModel;

	const isEdited = isShowPlanIncludedPrice.isEdited;
	const hasError = Boolean(isShowPlanIncludedPrice.error);

	const onSetIsShowPlanIncludedPrice = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "isShowPlanIncludedPrice",
					value: {
						...isShowPlanIncludedPrice,
						value: input,
					},
				},
			]);
		},
		[isShowPlanIncludedPrice, onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		isShowPlanIncludedPrice,
		onSetIsShowPlanIncludedPrice,
	};
};
